import React from "react";
import { Redirect, useLocation } from "react-router-dom";
import { get as getClientAuth } from "../services/localStorage";
import { hasDealerPortalAccess } from "../utils/dealerSessionSync";
import { isDealerUser } from "../utils/userTypes";

/**
 * Entire /dealers tree is dealer-only. Guests → /login; clients → /.
 */
export default function DealersPortalGate({ children, auth }) {
  const location = useLocation();

  if (hasDealerPortalAccess(auth)) {
    return children;
  }

  let clientAuth = {};
  try {
    clientAuth = getClientAuth({ key: "auth" }) || {};
  } catch (e) {
    clientAuth = {};
  }

  if (clientAuth.token && !isDealerUser(clientAuth)) {
    return <Redirect to="/" />;
  }

  return (
    <Redirect
      to={{
        pathname: "/login",
        state: { from: location },
      }}
    />
  );
}
